<template>
    <div>
        <v-combobox
            clearable
            :ref="refName"
            :items="StateS9Produtos"
            item-value="codigo"
            item-title="nome"
            hide-details
            @keyup.enter="pesquisarProduto"
            return-object
            v-model:search="search"
            @update:modelValue="onSelectProduto"
            :label="label"
            :placeholder="placeholder"
            :loading="StateS9ProdutosLoadingID === 'list-produtos'"
            >
            <template #append>
                <div>
                    <v-btn :disabled="!minCharsSearch"
                        @click="pesquisarProduto"
                        :loading="loading">
                        <v-icon>mdi-magnify</v-icon>
                        <span v-if="$vuetify.display.mdAndUp">Produto/Material</span>
                    </v-btn>
                </div>
            </template>
        </v-combobox>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
    props: {
        label: {
            required: false,
            default: 'Código do Produto, barras ou nome...'
        },
        placeholder: {
            required: false,
            default: 'Pesquisar'
        },
        refName: {
            required: false,
        },
        loading: {
            required: false,
            default: false
        },
    },
    data: ()=>({
        search:'',
        objeto_produto: {
            codigo: '',
            nome: ''
        }
    }),
    methods: {
        ...mapActions([
            'GetS9Produtos',
        ]),
        async pesquisarProduto(){
            if(!this.minCharsSearch) return
            const payload = {
                q: this.search
            }
            await this.GetS9Produtos(payload)
            try{
                this.$refs[this.refName].focus()
            }catch{
                //
            }
        },
        onSelectProduto(p){
            if(typeof(p) == 'string'){
                this.objeto_produto.codigo = p
            }
            if(typeof(p) == 'object'){
                try{
                    const { codigo, nome} = p
                    this.objeto_produto= { codigo, nome}
                }catch{
                    // destruct quando p é null
                }
            }
            this.$emit('select-produto', this.objeto_produto)
        }
    },
    computed: {
        ...mapGetters(['StateS9Produtos', 'StateS9ProdutosLoadingID']),
        minCharsSearch(){
            return (this.search||'').length >= 4
        }
    }
}
</script>